import { takeCustomLatest } from 'state/common/common.effects'
import { accountsAction } from 'state/new-summary/accounts/accounts.action'
import {
  fetchAccountSummaryEffect,
  downloadAccountSummaryEffect,
  fetchSpecificAccountSummaryEffect,
  downloadGroupAccountSummaryEffect
} from 'state/new-summary/accounts/accounts.effect'

function* fetchAccountsSummarySaga() {
  yield takeCustomLatest(accountsAction.FETCH_ACCOUNTS_SUMMARY, fetchAccountSummaryEffect)
}

function* fetchSpecificAccountsSummarySaga() {
  yield takeCustomLatest(
    accountsAction.FETCH_SPECIFIC_ACCOUNTS_SUMMARY,
    fetchSpecificAccountSummaryEffect
  )
}

function* downloadAccountsSummarySaga() {
  yield takeCustomLatest(accountsAction.DOWNLOAD_ACCOUNTS_SUMMARY, downloadAccountSummaryEffect)
}

function* downloadGroupAccountsSummarySaga() {
  yield takeCustomLatest(
    accountsAction.DOWNLOAD_GROUP_ACCOUNTS_SUMMARY,
    downloadGroupAccountSummaryEffect
  )
}

export const AccountSummaryGroupWatchers = [
  fetchAccountsSummarySaga(),
  downloadAccountsSummarySaga(),
  fetchSpecificAccountsSummarySaga(),
  downloadGroupAccountsSummarySaga()
]
